import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import { searchCompanies } from "../../ApisService/apiService";
import style from "../../../css/dashboard/fundamental/Searchbar.module.css";

const SearchBar = ({ onSelect }) => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState(true);

    const fetchResults = async (searchQuery) => {
        setLoading(true);
        try {
            const filteredResults = await searchCompanies(searchQuery);
            setResults(Array.isArray(filteredResults) ? filteredResults : []);
        } catch (error) {
            console.error("Search API error:", error);
            setResults([]);
        }
        setLoading(false);
    };
    

    const debouncedSearch = useCallback(debounce(fetchResults, 1000), []);

    useEffect(() => {
        if (query) {
            debouncedSearch(query);
        } else {
            setResults([]);
        }
        return () => debouncedSearch.cancel();
    }, [query]);

    const handleSelect = (company) => {
        if (onSelect && typeof onSelect === "function") {
            onSelect(company);
        }
        setQuery("");
        setResults([]);
        setExpanded(onSelect ? false : true); 
    };

    return (
        <>
            {expanded && <div className={style.overlay} onClick={() => setExpanded(false)}></div>}
            <div className={`${style.headsearch} ${expanded ? style.expanded : style.collapsed}`}>
                <div className={style.searchContainer}>
                    <div className={style.searchInputWrapper}>
                        {expanded && (
                            <input
                                type="text"
                                placeholder="Search for a company..."
                                className={style.searchInput}
                                value={loading ? "Loading..." : query}
                                onChange={(e) => !loading && setQuery(e.target.value)}
                                disabled={loading}
                            />
                        )}
                        <i className={`${style.searchIcon} fa-brands fa-searchengin `} onClick={() => setExpanded(!expanded)}> </i>
                    </div>
                    {results.length > 0 && expanded && (
                        <ul className={style.resultsList}>
                            {results.map((company, index) => (
                                <li
                                    key={index}
                                    className={style.resultItem}
                                    onClick={() => handleSelect(company)}
                                >
                                    <span className="font-medium">{company.scripname}</span> - {company.companyname}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </>
    );
};

export default SearchBar;